import clsx from 'clsx';
import styles from './ExternalLink.module.scss';

interface IExternalLinkProps {
  href: string;
  text: string;
  className?: string;
  onClick?: () => void;
}

export const ExternalLink: React.FC<IExternalLinkProps> = (
  props: IExternalLinkProps
) => {
  return (
    <a
      href={props.href}
      target="_blank"
      rel="noopener noreferrer"
      className={clsx(styles.disclaimerButtons, props.className)}
      onClick={props.onClick}
    >
      {props.text}
    </a>
  );
};
